import { render, staticRenderFns } from "./ActivationsHistory.vue?vue&type=template&id=42fcb382&"
import script from "./ActivationsHistory.vue?vue&type=script&lang=js&"
export * from "./ActivationsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports